import {
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import { useRecoilState } from 'recoil';
import styles from '../pages/appbar.module.css';
import { yearState } from '../recoil';
import { years } from '../utils/date';

type Props = {
  refetch: () => void;
};

const SelectYears = ({ refetch }: Props) => {
  const [year, setYear] = useRecoilState(yearState);

  const handleChange = (event: SelectChangeEvent) => {
    setYear(Number(event.target.value) as (typeof years)[number]);
    refetch();
  };

  return (
    <FormControl fullWidth>
      <Select
        name="years"
        id="year-select"
        onChange={handleChange}
        value={year?.toString()}
        className={styles.select}
      >
        {years.map((year, index) => (
          <MenuItem key={index} value={year}>
            {year}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
export default SelectYears;
